<div class="ui-grid" *ngIf="accessDetail && !accessDetail.hasAccess">
  <h1>Access Denied</h1>
</div>
<div class="ui-grid" *ngIf="dispute && accessDetail && accessDetail.hasAccess">
  <h1>Dispute Job No {{ dispute.jobNumber }}</h1>

  <div class="ui-g">
    <div class="ui-g-12 ui-md-2">
      <strong>Job Number</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.jobNumber }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Status</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      <span
        class="badge"
        [class.green]="dispute.status == 1"
        [class.orange]="dispute.status == 0"
        >{{ dispute.status == 1 ? 'Resolved' : 'Open' }}</span
      >
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Customer</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.customerCompanyName }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Contact</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.customerContactName }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Supplier</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.supplierCompanyName }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Contact</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.supplierContactName }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Created</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.createdOn | date : 'dd/MM/yyyy HH:mm' }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Last Updated</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ dispute.lastUpdated | date : 'dd/MM/yyyy HH:mm' }}
    </div>

    <div class="ui-g-12 ui-md-2">
      <strong>Dispute Description</strong>
    </div>
    <div id="DisputeDescription" class="ui-g-12 ui-md-10">
      {{ dispute.description }}
    </div>

    <div class="ui-g-12 ui-md-12">
      <hr />
    </div>

    <div class="ui-g-12 ui-md-12">
      <strong>History</strong>
    </div>

    <ng-template ngFor let-dd [ngForOf]="dispute.disputeMessages" let-i="index">
      <div class="ui-g-12 ui-md-12 ui-g-nopad ui-card">
        <div class="ui-g-12 ui-md-2">
          <strong>Date Added</strong>
        </div>
        <div class="ui-g-12 ui-md-4">
          {{ dd.timeStamp | date : 'dd/MM/yyyy HH:mm' }}
        </div>
        <div class="ui-g-12 ui-md-2">
          <strong>Added By</strong>
        </div>
        <div class="ui-g-12 ui-md-4">
          {{ dd.userName }}
        </div>
        <div id="TextDescription" class="ui-g-12 ui-md-12">
          {{ dd.text }}
        </div>
      </div>
    </ng-template>

    <form
      [formGroup]="newMessageform"
      id="add-details-form"
      class="ui-g-12 ui-md-12 ui-g-nopad"
      (ngSubmit)="onSubmit()"
      #addDisputeDetailForm="ngForm"
      *ngIf="!dispute.isResolved"
    >
      <div class="ui-g-12 ui-md-12">
        <strong>Add new text</strong>
      </div>
      <div class="ui-g-12 ui-md-10">
        <textarea
          [(ngModel)]="saveDisputeDetails.text"
          class="ui-inputtextarea"
          pInputTextarea
          ngModel
          name="text"
          formControlName="newMessage"
          required
        ></textarea>
      </div>
      <div class="ui-g-12 ui-md-2" style="min-width: 100px">
        <div class="ui-grid">
          <div class="ui-grid-row">
            <button
              type="button"
              (click)="onSubmit()"
              class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only green-btn"
              pButton
              [disabled]="newMessageform.invalid"
            >
              <span class="ui-button-text ui-c">Save Text</span>
            </button>
          </div>
          <div class="ui-grid-row">
            <button
              type="button"
              (click)="onCloseDispute()"
              pButton
              [disabled]="dispute.status == 1"
            >
              <span class="ui-button-text ui-c">Mark as Resolved</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-g-12 ui-md-12">
    <button type="button" (click)="back()" pButton label="Back"></button>
    <!--<a class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only" [routerLink]="['..']" title="Go back" pButton>
            <span class="ui-button-text ui-c">Back</span>
        </a>-->
  </div>
</div>
<div *ngIf="isLoading">Loading...</div>
<div *ngIf="notFound">Dispute not found.</div>
<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
